import { render } from "./Offer.vue?vue&type=template&id=4ca78511&scoped=true"
const script = {}

import "./Offer.vue?vue&type=style&index=0&id=4ca78511&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ca78511"]])

export default __exports__